/* src/app/_shared/components/separator/separator.component.scss */
:host {
  --color: #ccc;
  --height: 1px;
}
.separator {
  border: none;
  height: var(--height);
  background-color: var(--color);
  margin: 0;
}
/*# sourceMappingURL=separator.component.css.map */
